// src/utils/socket.js
import { io } from "socket.io-client";

const rawBase = process.env.REACT_APP_API_BASE || "http://localhost:5000";
const API_ORIGIN = String(rawBase).replace(/\/+$/, "");

export function createSocket(token) {
  // ✅ don't connect if no token
  if (!token) return null;

  // ✅ Render websocket upgrade is often flaky -> force polling
  const isRender = API_ORIGIN.includes("onrender.com");

  return io(API_ORIGIN, {
    path: "/socket.io",
    auth: { token },
    withCredentials: true,
    autoConnect: true,

    // ✅ Best fix for your error
    transports: isRender ? ["polling"] : ["polling", "websocket"],
    upgrade: !isRender,
    rememberUpgrade: !isRender,

    // ✅ stability
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    timeout: 20000,
  });
}